import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, TextArea, Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const MNCForm = ({ section, type }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};

	return (
		<>
			{section.sectionName === "Mnc" && (
				<MDBRow className="mt-4">
					{section?.fields?.map((formField, fieldIndex) => (
						<MDBCol
							md="3"
							className="pr-2 mt-3"
							key={`${formField.key}-${fieldIndex}`}
						>
							{formField.dataType === "decimal" && (
								<>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>
									<Controller
										name={
											sanitizeKey(formField.key)
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										render={({ field }) => {
											// Ensure field is defined before accessing properties
											if (!field) return null; // Return null if field is undefined

											return (
												<Input
													autoFocus={false}
													{...field} // Spread the field props from Controller
													className="inputHeight"
													type="number"
													step="any"
													onChange={(e) => {
														// Check if field.onChange is available before calling it

														field.onChange(e);
													}}
													value={field?.value ?? ""} // Safely use field.value or fallback to ''
													onKeyDown={(e) => {
														preventScientificNotation(
															e
														);
														// Prevent up and down arrow keys
														if (
															e.key ===
															"ArrowUp" ||
															e.key ===
															"ArrowDown"
														) {
															e.preventDefault();
														}
													}}
													onWheel={(e) =>
														e.target.blur()
													}
												/>
											);
										}}
									/>
								</>
							)}
						</MDBCol>
					))}
				</MDBRow>
			)}

			{section.sectionName === "Deduction" && (
				<MDBRow className="mt-4">
					{section?.fields?.map((formField, fieldIndex) => (
						<MDBCol
							md="3"
							className="pr-2 mt-3"
							key={`${formField.key}-${fieldIndex}`}
						>
							{formField.dataType === "decimal" && (
								<>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>
									<Controller
										name={
											sanitizeKey(formField.key)
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										render={({ field }) => {
											// Ensure field is defined before accessing properties
											if (!field) return null; // Return null if field is undefined

											return (
												<Input
													autoFocus={false}
													{...field} // Spread the field props from Controller
													className="inputHeight"
													type="number"
													step="any"
													onChange={(e) => {
														// Check if field.onChange is available before calling it

														field.onChange(e);
													}}
													value={field?.value ?? ""} // Safely use field.value or fallback to ''
													onKeyDown={(e) => {
														preventScientificNotation(
															e
														);
														// Prevent up and down arrow keys
														if (
															e.key ===
															"ArrowUp" ||
															e.key ===
															"ArrowDown"
														) {
															e.preventDefault();
														}
													}}
													onWheel={(e) =>
														e.target.blur()
													}
												/>
											);
										}}
									/>
								</>
							)}
						</MDBCol>
					))}
				</MDBRow>
			)}
			{section.sectionName === "Remarks" && (
				<>
					<MDBRow className="mt-4">
						{section?.fields?.map((formField, fieldIndex) => (
							<MDBCol
								md={
									formField.fieldName ==
										"AMOUNT OF CARBON CAPTURE STORAGE"
										? "4"
										: "3"
								}
								className="pr-2 mt-3"
								key={`${formField.key}-${fieldIndex}`}
							>
								{formField.dataType === "decimal" && (
									<>
										<Label
											bold
											name={formField.fieldName}
											className="mb-1"
										/>
										<Controller
											name={
												formField.key
													? formField.key.replace(
														"|",
														""
													)
													: ""
											}
											control={control}
											defaultValue={
												type === "Edit"
													? formField.value || null
													: ""
											}
											render={({ field }) => {
												// Ensure field is defined before accessing properties
												if (!field) return null; // Return null if field is undefined

												return (
													<Input
														autoFocus={false}
														{...field} // Spread the field props from Controller
														className="inputHeight"
														type="number"
														step="any"
														onChange={(e) => {
															// Check if field.onChange is available before calling it

															field.onChange(e);
														}}
														value={
															field?.value ?? ""
														} // Safely use field.value or fallback to ''
														onKeyDown={(e) => {
															preventScientificNotation(
																e
															);
															// Prevent up and down arrow keys
															if (
																e.key ===
																"ArrowUp" ||
																e.key ===
																"ArrowDown"
															) {
																e.preventDefault();
															}
														}}
														onWheel={(e) =>
															e.target.blur()
														}
													/>
												);
											}}
										/>
									</>
								)}
							</MDBCol>
						))}
					</MDBRow>
					<MDBRow className="mt-4">
						{section?.fields
							?.filter(
								(formField) => formField.fieldName === "REMARKS"
							) // Filter to include only the REMARKS field
							.map((formField, fieldIndex) => (
								<MDBCol
									md="12"
									className="pr-2 mt-3"
									key={`${formField.key}-${fieldIndex}`}
								>
									{formField.dataType === "string" &&
										formField.fieldName === "REMARKS" && (
											<>
												<Label
													bold
													name={formField.fieldName}
													className="mb-1"
												/>
												<Controller
													name={
														formField.key
															? formField.key.replace(
																"|",
																""
															) // Clean up the key if necessary
															: ""
													}
													control={control}
													defaultValue={
														type === "Edit"
															? formField.value ||
															null
															: ""
													}
													render={({ field }) => {
														if (!field) return null; // Return null if field is undefined

														return (
															<TextArea
																className="textarea-resize"
																value={
																	field.value
																}
																onChange={
																	field.onChange
																}
															/>
														);
													}}
												/>
											</>
										)}
								</MDBCol>
							))}
					</MDBRow>
				</>
			)}
		</>
	);
};

export default MNCForm;
